export const AUTHORIZATION_HEADER = 'Authorization';
export const TENANT_HEADER = 'X-API-TENANT';

export const BEARER_PREFIX = 'Bearer';

export const ACCESS_TOKEN_KEY = 'accessToken';
